/**
 * The type of redux action which stores a specific JSON Web Token (JWT) into
 * the redux store.
 *
 * {
 *     type: SET_USERDATA,
 *     jwt: string
 * }
 */
export const SET_UI_FONTSIZE = 'SET_UI_FONTSIZE';
export const SET_UI_ICONSIZE = 'SET_UI_ICONSIZE';
export const SET_VISUAL_CUES_ENABLED_STATE = 'SET_VISUAL_CUES_ENABLED_STATE';
export const SET_AUDIO_CUES_ENABLED_STATE = 'SET_AUDIO_CUES_ENABLED_STATE';
export const SET_INTERPRETER_VIDEO_ENABELD_STATE = 'SET_INTERPRETER_VIDEO_ENABELD_STATE';
